export const formatToReadableDate = (dateStr: string | Date): string => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatDeliveryDate = (deliveryDays: number) => {
  const today = new Date();

  const deliveryDate = new Date(today);
  deliveryDate.setDate(today.getDate() + Number(deliveryDays));

  const day = String(deliveryDate.getDate()).padStart(2, "0");
  const year = String(deliveryDate.getFullYear() % 100).padStart(2, "0");
  const month = deliveryDate.toLocaleString("en-US", { month: "long" });

  let formattedMonth = month;
  if (
    [
      "January",
      "February",
      "March",
      "April",
      "August",
      "September",
      "October",
      "November",
      "December",
    ].includes(month)
  ) {
    formattedMonth = `${month.slice(0, 3)}`;
  }

  return `${day} ${formattedMonth} '${year}`;
};

export const getTimeAgo = (dateString: string): string => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (seconds < 60) return "just now";
  if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  return `${days} day${days > 1 ? "s" : ""} ago`;
};

export const getDaysUntilDateString = (targetDateStr: string): number => {
  // Expects format like '20July 2025'
  if (!targetDateStr) return 0;
  const targetDate = new Date(targetDateStr);
  const today = new Date();
  targetDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = targetDate.getTime() - today.getTime();

  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const getStrapiFormattedDate = (timestamp: any, locale = "en-IN") => {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  const [day, month, year] = date
    .toLocaleDateString(locale, {
      day: "numeric",
      month: "short",
      year: "numeric",
    })
    .split(" ");

  const timeString = date
    .toLocaleTimeString(locale, {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    })
    .toLocaleUpperCase();

  const timeZone = "IST";

  return `${day} ${month}, ${year}, ${timeString} ${timeZone}`;
};

export const getDaysFromTomorrow = (targetDateStr: string): number => {
  if (!targetDateStr) return 0;
  const targetDate = new Date(targetDateStr);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate());

  targetDate.setHours(0, 0, 0, 0);
  tomorrow.setHours(0, 0, 0, 0);

  const diffTime = targetDate.getTime() - tomorrow.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return Math.max(0, diffDays);
};

export function formatFullDate(rawDate: string) {
  const date = new Date(rawDate);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = String(date.getFullYear() % 100).padStart(2, "0");
  return `${day} ${month} '${year}`;
}

export const formatReportDate = (report_date: any) => {
  const year = report_date.year % 100;

  const shortMonths = ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  const formattedMonth = shortMonths[report_date.month - 1];

  return `${formattedMonth} '${year}`;
};